import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { categories } from "../data/categories";
import "./BookingForm.css";

const WHATSAPP_NUMBER = "306949794405";

export default function BookingForm({ isOpen, onClose, initialProduct = "" }) {
  const [formData, setFormData] = useState({
    fullName: "",
    selectedItem: initialProduct,
    notes: "",
  });

  useEffect(() => {
    if (isOpen) {
      setFormData((prev) => ({ ...prev, selectedItem: initialProduct }));
    }
  }, [isOpen, initialProduct]);

  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const message =
      `Order Request:\n\n` +
      `Full Name: ${formData.fullName}\n` +
      `Selected Product: ${formData.selectedItem}\n` +
      `Notes: ${formData.notes || "None"}`;

    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
    onClose();
  };

  return (
    <div className="booking-modal" onClick={onClose}>
      <div className="booking-section" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Close">
          <X size={20} />
        </button>

        <h2>Order Your Product</h2>
        <p className="booking-intro">
          Send us a screenshot of the item you&apos;re interested in, or contact us directly to
          discuss your requirements and receive personalised assistance.
        </p>

        <form className="booking-form" onSubmit={handleSubmit}>
          <label>
            Full Name
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Select Product
            <select name="selectedItem" value={formData.selectedItem} onChange={handleChange} required>
              <option value="">-- Select a Product --</option>
              {categories.map((category) => (
                <option key={category.slug} value={category.orderLabel}>
                  {category.orderLabel}
                </option>
              ))}
            </select>
          </label>

          <label>
            Notes (Optional)
            <textarea name="notes" value={formData.notes} onChange={handleChange} />
          </label>

          <button type="submit" className="send-button">
            <FaWhatsapp size={20} />
            Send via WhatsApp
          </button>
        </form>
      </div>
    </div>
  );
}
